import { SegmentEventName } from "@tsTypes/__generated__/enums";
import { track } from "@utils/appUtils";
import { useEffect } from "react";

function useImpression(ui_component: string) {
  useEffect(() => {
    track(SegmentEventName.VIEW, {
      ui_component,
    });
  }, [ui_component]);
}

export default useImpression;
